var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"left-middle",attrs:{"title":"物联网故障数据统计图"}},[_c('div',{staticClass:"pie",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"main1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }